// extracted by mini-css-extract-plugin
export default {"container":"UsingNoviopus_container__bbtA+","content":"UsingNoviopus_content__Wxe4H"};